import { c as _c } from "react/compiler-runtime";
import CeoSection from "./CeoSection";
import SuperTitle from "../../common/supertitle/supertitle";
import PersonCard from "../ui/PersonCard";
import { ExecFeatureData, LeadershipGridData } from "@/sanity/interfaces";
interface LeadershipSectionProps {
  leadershipGrid: LeadershipGridData;
  execFeature: ExecFeatureData;
}
const LeadershipSection = props => {
  const $ = _c(18);
  const {
    leadershipGrid,
    execFeature
  } = props;
  const {
    heading,
    people,
    subheading
  } = leadershipGrid;
  if (!people || people.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== execFeature) {
    t0 = execFeature && <CeoSection data={execFeature} />;
    $[0] = execFeature;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SuperTitle>our leadership</SuperTitle>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== heading) {
    t2 = <h2>{heading}</h2>;
    $[3] = heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== subheading) {
    t3 = <p>{subheading}</p>;
    $[5] = subheading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="mb-12 mt-10 flex flex-col gap-4 lg:mt-16 lg:items-center lg:justify-center lg:text-center"><>{t1}{t2}{t3}</></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== people) {
    t5 = people.map(_temp);
    $[10] = people;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4">{t5}</div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t0 || $[15] !== t4 || $[16] !== t6) {
    t7 = <section className="mt-0 md:mb-10">{t0}{t4}{t6}</section>;
    $[14] = t0;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default LeadershipSection;
function _temp(member, index) {
  return <PersonCard key={index} person={member} />;
}